export default "__VITE_ASSET__47618a2a__"